module.exports = __webpack_public_path__ + "media/site_templates/www.polishingfloorboards.com.au/images/about_us-08e2e1fec0092b55a099ba7bdc2548e6.jpg";